import script from "./ConnectSocialDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectSocialDialog.vue?vue&type=script&setup=true&lang=js"

import "./ConnectSocialDialog.vue?vue&type=style&index=0&id=37f4e9de&lang=scss"

const __exports__ = script;

export default __exports__